import { RootScopeEvents } from './../../../../common/services/root-scope-types';
import { AbstractRealtimeComponent } from '../../abstract-realtime-component';
const getPatientErrorMessage = (patientSettings) => {
    let settings = patientSettings;
    if (!settings) {
        settings = { supported: null, extensionInstalled: null };
    }
    if (patientSettings.supported === false) {
        return 'screenshare-patient-not-supported';
    }
    if (patientSettings.extensionInstalled === false) {
        return 'Your patient needs to install the screensharing extension';
    }
    return "There was a problem getting access to your patient's screen. Please try again.";
};
export default class ScreenshareDoctorRealtimeComponent extends AbstractRealtimeComponent {
    /* @ngInject */
    constructor(doctorScreensharePopup, trackingFactory, // still in js
    globalUi, notificationFactory, // still in js
    VideoProviderFactory, $rootScope, doctorRealtimeActions, screenshareFactory // still in js
    ) {
        super();
        this.doctorScreensharePopup = doctorScreensharePopup;
        this.trackingFactory = trackingFactory;
        this.globalUi = globalUi;
        this.notificationFactory = notificationFactory;
        this.VideoProviderFactory = VideoProviderFactory;
        this.$rootScope = $rootScope;
        this.doctorRealtimeActions = doctorRealtimeActions;
        this.screenshareFactory = screenshareFactory;
        this.isTracked = false;
        $rootScope.$on('screenshareStopped', () => {
            // screenshareStopped event is emitted twice in TokboxVideoProvider class when patient's tab was closed
            // isTracked is used to skip 'Stopped' event duplication
            if (!this.isTracked) {
                this.trackingFactory.global.trackScreenshare('Ended');
                this.isTracked = true;
            }
            this.reset();
        });
        $rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.SCREEN_SHARE_STARTED, (_e, { withAudio }) => {
            this.trackingFactory.global.trackScreenshare('Started', {
                with_audio: withAudio,
            });
            this.isTracked = false;
        });
        $rootScope.$on('otScreenPublisher:error', (_event, error) => {
            this.screenshareFactory.handleError(error);
        });
    }
    create() {
        return this;
    }
    hideModal() {
        this.doctorScreensharePopup.hide();
    }
    onLeave(person) {
        if (this.availablePeople.length === 0) {
            this.reset();
            return;
        }
        if (!this.globalUi.ui.screenSharePatient) {
            return; // if already destroyed
        }
        if (!this.globalUi.ui.screenSharePatient.isEqualTo(person)) {
            return;
        }
        // Track screenshare Ended when patient was sharing and closed tab
        this.trackingFactory.global.trackScreenshare('Ended');
        this.reset();
    }
    reset() {
        this.hideModal();
        this.globalUi.ui.screenSharePatient = null;
        this.globalUi.ui.screenSharing = false;
    }
    onMessage(message) {
        switch (message.action) {
            case 'screenshareSuccess': {
                const successMessage = message;
                this.trackingFactory.global.trackScreenshare('Started', {
                    with_audio: successMessage.content.withAudio,
                });
                this.isTracked = false;
                this.onPatientSuccess();
                break;
            }
            case 'screenshareError': {
                this.onPatientError(message);
                break;
            }
            case 'screenshareStopped': {
                if (this.globalUi.ui.screenSharing ||
                    this.globalUi.ui.screenSharePatient) {
                    this.trackingFactory.global.trackScreenshare('Ended');
                }
                this.onPatientStop();
                break;
            }
            default:
                throw new Error(`Unhandled screenshare message case: ${message.action}`);
        }
    }
    async open({ peopleAvailable, }) {
        this.availablePeople = peopleAvailable;
        await this.doctorScreensharePopup.open({
            patients: peopleAvailable.models,
            ui: this.globalUi.ui,
            startScreensharing: async () => {
                if (this.globalUi.ui.screenSharePatient) {
                    this.notificationFactory.showCommon('info', 'screenshare-can-only-one-person');
                    return;
                }
                await this.startScreensharing();
            },
            stopScreensharing: () => {
                this.stopScreensharing();
            },
            isPersonSharingDisabled: (person) => {
                return this.isPersonSharingDisabled(person);
            },
            requestScreensharing: (person) => {
                if (this.isPersonSharingDisabled(person)) {
                    this.notificationFactory.showCommon('info', 'screenshare-can-only-one-person');
                    return;
                }
                if (person.isUndetermined) {
                    this.notificationFactory.showCommon('error', 'undetermined-person-in-extension');
                    return;
                }
                if (!person.canShareScreen()) {
                    this.notificationFactory.showCommon('info', 'screenshare-patient-not-supported');
                    return;
                }
                this.globalUi.ui.screenSharePatient = person;
                this.doctorRealtimeActions.sendToTarget(person, {
                    action: 'screenshareRequest',
                    componentName: 'screenshare',
                });
            },
        });
    }
    isPersonSharingDisabled(person) {
        return ((this.globalUi.ui.screenSharing &&
            !this.globalUi.ui.screenSharePatient) ||
            (this.globalUi.ui.screenSharePatient &&
                this.globalUi.ui.screenSharePatient.uuid !== person.uuid));
    }
    stopScreensharing() {
        if (this.globalUi.ui.screenSharePatient) {
            return;
        }
        this.globalUi.ui.screenSharing = false;
    }
    onPatientStop() {
        if (this.globalUi.ui.isRestartingCall) {
            return;
        }
        this.globalUi.ui.screenSharePatient = null;
        this.globalUi.ui.screenSharing = false;
        this.doctorScreensharePopup.hide();
        this.reset();
    }
    async startScreensharing() {
        await this.VideoProviderFactory.activeProvider.toggleScreenSharing();
        this.$rootScope.$applyAsync(() => {
            this.globalUi.ui.screenSharing = true;
        });
    }
    onPatientSuccess() {
        // noop
    }
    onPatientError(message) {
        this.notificationFactory.showCommon('info', getPatientErrorMessage(message.content.screenshareSettings));
        this.globalUi.ui.screenSharePatient = null;
    }
}
